import { generateMessage } from 'utils/formatReportMessage';

export const SUCCESS_MESSAGE = 'Your request was successfully submitted';
export const FAILURE_MESSAGE = 'Something went wrong. Please check console';
export const REFRESH_MESSAGE =
  'New data just came. Please press on this notification to refresh the page';
export const successMessages = {
  changes: 'Changes were successfully saved',
  reviewed: 'This reading has been successfully reviewed',
  sendReport: 'Your report will be created. Please check your email shortly.',
  deleted: 'Successfully deleted',
  reportReady: (reportType) => generateMessage(reportType),
};
export const errorMessages = {
  report: (reportType, message) =>
    `Error when generate report ${reportType}: ${message}`,
};
